<template>
  <div id="organizationMapBox2">
    <div id="organizationMap2"></div>
  </div>
</template>

<script>
function noop() {
}

import AMap from "AMap"; // 引入高德地图
import {post} from "@/api/requrestHttp";

export default {
  name: "mapLocation",
  props: {
    val: {
      default: ""
    },
    center: {
      default: ""
    },
    orgId: {
      default: null
    },
    onSuccess: {
      type: Function,
      default: noop
    },
    disabled: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      baseForm: {longitude: "", latitude: ""},
    };
  },
  computed: {},
  methods: {
    changeLocation(e) {
      //this.debounce(this.debounce(e),1000)
    },
    //根据输入地址转换经纬度并标记

    setmarkerFunc(longitude, latitude) {
      this.mapmarker.setPosition([longitude, latitude]);

      // this.mapcontainer.add(this.mapmarker);
      this.mapcontainer.setFitView(this.mapmarker);
      // this.circle.setCenter([longitude, latitude]);
    },
    //初始化地图插件的方法
    mapInit(containerId) {
      let center
      if (this.center) {
        center = new AMap.LngLat(this.center[0], this.center[1])
      } else {
        center = [117.494476, 30.64932]
      }
      this.mapcontainer = new AMap.Map(containerId, {
        // mapStyle: "amap://styles/darkblue",
        //  mapStyle: "amap://styles/4f2131e7288788c62b63fc7957674ba0",
        zoom: 15,
        zooms: [3, 20],
        expandZoomRange: true,
        center,  //初始化地图中心点
      });
      this.mapmarker = new AMap.Marker({
        map: this.mapcontainer
      });

      if (this.val) {
        let s = this.val.split(",");
        this.setmarkerFunc(s[0], s[1]);
      }
      //定义地图坐标点击事件
      this.mapcontainer.on("click", e => {
        if (this.disabled) {
          return false;
        }
        this.setmarkerFunc(e.lnglat.getLng(), e.lnglat.getLat());

        // this.$emit(
        //     "input",
        //     `${e.lnglat.getLng()},${e.lnglat.getLat()}`
        // );
        this.onSuccess(`${e.lnglat.getLng()},${e.lnglat.getLat()}`);
      });

      this.circle = new AMap.Circle({
        center,
        radius: 0, //半径
        borderWeight: 3,
        strokeColor: "#FF33FF",
        strokeOpacity: 1,
        strokeWeight: 6,
        fillOpacity: 0.4,
        strokeStyle: 'dashed',
        strokeDasharray: [10, 10],
        // 线样式还支持 'dashed'
        fillColor: '#1791fc',
        zIndex: 50,
      })

      this.circle.setMap(this.mapcontainer)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mapInit("organizationMap2");
    });
  },
  created() {
  },
  watch: {
    val(newVal, old) {
      if (newVal) {
        let s = newVal.split(",");
        this.setmarkerFunc(s[0], s[1]);
      }
    },
    center(newVal, old) {
      this.$nextTick(() => {
        this.mapInit("organizationMap2");
      });
      let position = new AMap.LngLat(newVal[0], newVal[1])
      // this.circle.setRadius(newVal);
      // console.log(this.circle)
      this.mapcontainer.setCenter(position);
      this.circle.setCenter(position)
      console.log(this.circle.getCenter());
      this.mapmarker.setPosition(position)
    }
  }
};
</script>
<style lang="less">
#organizationMap2 {
  width: 100%;
  height: 100%;
}
</style>
